module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section03_01_american-village-9c37a6fb9c8fd882dbba081ed616cb4d.jpg";